module.exports = __webpack_public_path__ + "static/media/18ECA52.866645f0.jpg";